// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-box {
  position: relative;
  top: 90px;
  left: 20px;
  z-index: 5;
  font-size: 22px;
  font-weight: 800;
}

.overview-container {
  height: 50%;
  width: 100%;
  margin-bottom: 100px;
  margin-top: -5.5em;
}

.overview-map-title {
  margin-left: 0.5em;
}

.dropdowns-towns {
  position: relative;
  z-index: 10;
  top: 50px;
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end !important;
  background-color: rgba(0, 0, 0, 0);
}

.dropdowns-button {
  background-color: #FFFFFF !important;
  width: 350px;
  text-align: left;
  align-items: flex-start;
  color: #8F003C !important;
  font-weight: 750;
  border: 1px solid #CCCCCC !important;
}

.dropdowns-button::marker {
  background-color: red !important;
}

.overview-member-select {
  position: absolute;
  right: 2em;
  width: 20em;
}`, "",{"version":3,"sources":["webpack://./src/components/mapoverview/MapOverview.scss","webpack://./src/components/mapoverview/MapOverview.css"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;ACCJ;;ADEA;EACI,WAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,kBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,+BAAA;EACA,kCAAA;ACCJ;;ADEA;EACI,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oCAAA;ACCJ;;ADCA;EACI,gCAAA;ACEJ;;ADCA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;ACEJ","sourcesContent":[".title-box {\n    position: relative;\n    top: 90px;\n    left: 20px;\n    z-index: 5;\n    font-size: 22px;\n    font-weight: 800;\n}\n\n.overview-container {\n    height: 50%;\n    width: 100%;\n    margin-bottom: 100px;\n    margin-top: -5.5em;\n}\n\n.overview-map-title{\n    margin-left: .5em;\n}\n\n.dropdowns-towns{\n    position: relative;\n    z-index: 10;\n    top: 50px;\n    right: 0;\n    display: flex;\n    justify-content: flex-end;\n    align-self: flex-end !important;\n    background-color: rgb(0,0,0,0);\n}\n\n.dropdowns-button{\n    background-color: #FFFFFF !important;\n    width: 350px;\n    text-align: left;\n    align-items: flex-start;\n    color: #8F003C !important;\n    font-weight: 750;\n    border: 1px solid #CCCCCC !important;\n}\n.dropdowns-button::marker{\n    background-color: red !important;\n}\n\n.overview-member-select {\n    position: absolute;\n    right: 2em;\n    width: 20em;\n}",".title-box {\n  position: relative;\n  top: 90px;\n  left: 20px;\n  z-index: 5;\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.overview-container {\n  height: 50%;\n  width: 100%;\n  margin-bottom: 100px;\n  margin-top: -5.5em;\n}\n\n.overview-map-title {\n  margin-left: 0.5em;\n}\n\n.dropdowns-towns {\n  position: relative;\n  z-index: 10;\n  top: 50px;\n  right: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-self: flex-end !important;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.dropdowns-button {\n  background-color: #FFFFFF !important;\n  width: 350px;\n  text-align: left;\n  align-items: flex-start;\n  color: #8F003C !important;\n  font-weight: 750;\n  border: 1px solid #CCCCCC !important;\n}\n\n.dropdowns-button::marker {\n  background-color: red !important;\n}\n\n.overview-member-select {\n  position: absolute;\n  right: 2em;\n  width: 20em;\n}/*# sourceMappingURL=MapOverview.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
